import { Pipe, PipeTransform } from '@angular/core';
import { NumberUtilities } from 'src/app/core/utilities/number.utilities';

@Pipe({name: 'percentFormatter'})
export class PercentFormatterPipe implements PipeTransform {
  transform(value: number, digits: number = 0): string {
    return NumberUtilities.formatAsPercentage(value, digits);
  }
}
